import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { all_countries, Country } from '../data/countries';
import { all_provinces, Province } from "../data/provinces";
import { BreakpointObserver } from '@angular/cdk/layout';
import { StepperOrientation } from '@angular/material/stepper';
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { LoaderService } from "src/core/services/loader.service";

import { Individual, IndividualType } from "src/interfaces/individual";
import { Medicine } from "src/interfaces/medicine";
import { FormService } from "../../services/form.service";
import { DeliveryType } from 'src/interfaces/delivery-type';
import { OrderItem, OrderItemStatus } from "src/interfaces/order-item";
import { Router } from '@angular/router';
import { Company, CompanyType } from 'src/interfaces/company';
import { CanAddAndRemoveOrderItem } from "src/interfaces/can-add-and-remove-order-item";
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { EntityType as EntityTypeEnum } from "src/enums/entity-type";
import { MatStepper } from '@angular/material/stepper';
import { BatchStatus } from 'src/interfaces/batch';
import { Order } from 'src/interfaces/order';
import { DirtinessService } from 'src/core/services/dirtiness.service';
import { IndividualService } from 'src/core/services/individual.service';
import { Address } from 'src/interfaces/address';
import { CompanyService } from 'src/core/services/company.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { PrescriptionCreatePayload } from 'src/interfaces/prescription';

@Component({
  selector: 'form-client-form',
  templateUrl: './client-form.component.html',
  styleUrls: ['./client-form.component.scss'],
})
export class ClientFormComponent implements OnInit, CanAddAndRemoveOrderItem {

  countries: Country[] = all_countries;
  provinces: Province[] = all_provinces;
  companies: Company[] = [];
  filteredCompanies: Observable<Company[]>;
  selectedCompany: Company | null = null;
  selectedPrescriber: Individual | null = null;
  selectedDistributor: Company | null = null;
  showDistributor: boolean = false;

  selectedIndividual: Individual | null = null;
  individuals: Individual[] = [];

  addresses: Address[] = [];

  filteredMedicine: Observable<Medicine[]>;
  fileKey: string = "";
  acceptFiles: string = ".pdf"
  allMedicine: Medicine[] = [];
  orderItems: OrderItem[] = [];
  order: Order | null = null;

  EntityType = EntityTypeEnum;
  entityTypes: EntityTypeEnum[] = [
    EntityTypeEnum.Individual,
    EntityTypeEnum.Company,
  ]

  isEditable: boolean = true;
  disableSaveButton: boolean = false;

  @ViewChild('stepper') private _stepper: MatStepper;

  selectEntityTypeForm = this._formBuilder.group({
    entityType: ['', Validators.required]
  })

  uploadPrescriptionForm = this._formBuilder.group({
    prescription: [null, Validators.required]
  })

  searchControl = this._formBuilder.control(['']);

  individualDetailsForm = this._formBuilder.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    title: ['', Validators.required],
    initials: ['', Validators.required],
    isAnimal: ['', Validators.required],
    gender: ['', Validators.required],
    dateOfBirth: ['', Validators.required],
    phoneNumber: ['', Validators.compose([Validators.required, Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$')])],
    phoneNumberAlt: ['', Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$')],
    email: ['', Validators.compose([Validators.required, Validators.email])],
    emailAlt: ['', Validators.email],
    individualType: ['', Validators.required],
    numberOfDependants: ['0', Validators.min(0)],
  });

  addressDetailsForm = this._formBuilder.group({
    buildingAptNumber: ['', Validators.required],
    addressLine1: ['', Validators.required],
    addressLine2: [''],
    province: ['', Validators.required],
    city: [''],
    postcode: ['', Validators.compose([Validators.required, Validators.pattern(/^[0-9]{4,5}$/)])],
    country: ['South Africa', Validators.required],
    deliveryType: ['', Validators.required]
  });


  companyDetailsForm = this._formBuilder.group({
    companyName: ['', Validators.required],
    email: ['', Validators.compose([Validators.required, Validators.email])],
    emailAlt: ['', Validators.email],
    phoneNumber: ['', Validators.compose([Validators.required, Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$')])],
    phoneNumberAlt: ['', Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$')],
    practiceNumber: ['', Validators.required],
    vatRegistrationNumber: ['', Validators.pattern(/[0-9]+/)],
    typeOfBusiness: ['', Validators.required],
    distributor: [''],
  });


  prescriberDetailsForm = this._formBuilder.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    title: ['', Validators.required],
    initials: ['', Validators.required],
    isAnimal: ['', Validators.required],
    gender: ['', Validators.required],
    dateOfBirth: ['', Validators.required],
    phoneNumber: ['', Validators.compose([Validators.required, Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$')])],
    phoneNumberAlt: ['', Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$')],
    email: ['', Validators.compose([Validators.required, Validators.email])],
    emailAlt: ['', Validators.email],
    individualType: ['', Validators.required],
    numberOfDependants: ['0', Validators.min(0)],
  });

  additionalDetailsForm = this._formBuilder.group({
      customerOrderNumber: ['']   
  });
  displayPrescriberDetailsForm: boolean = false;



  stepperOrientation: Observable<StepperOrientation>;
  isSmallScreen: Observable<boolean>;

  individualTypes: IndividualType[] = [];
  allIndividualTypes: IndividualType[] = [];
  deliveryTypes: DeliveryType[] = [];
  companyTypes: CompanyType[] = [];
  orderItemStatuses: OrderItemStatus[] = [];
  batchStatuses: BatchStatus[] = [];
  isLoading: boolean = false;
  filteredCountriesForIndividual: Observable<Country[]>;
  companyName: string | null = null;
  customerOrderNumber: string | null = null;
  individualFirstName: string | null = null;
  individualLastName: string | null = null;


  constructor(
    private _formBuilder: FormBuilder,
    private _formService: FormService,
    private _loaderService: LoaderService,
    private _breakpointObserver: BreakpointObserver,
    private _router: Router,
    private _dirtinessService: DirtinessService,
    private _individualService: IndividualService,
    private _companyService: CompanyService
  ) {

  }

  ngOnInit(): void {

    this.stepperOrientation = this
      ._breakpointObserver
      .observe('(min-width: 900px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));

    this.isSmallScreen = this
      ._breakpointObserver
      .observe('(min-width: 900px)')
      .pipe(map(({ matches }) => (matches ? true : false)));

    this.filteredCountriesForIndividual = this
      .addressDetailsForm
      .controls['country']
      .valueChanges
      .pipe(
        startWith('South Africa'),
        map(value => this._filterCountries(value))
      );

    this
      ._loaderService
      .isLoading
      .subscribe(isLoading => {
        this.isLoading = isLoading;
      });

    this
      ._formService
      .getMedicine(1, 30)
      .subscribe(medicine => {
        this.allMedicine = medicine;
      });

    this
      ._formService
      .getFormData([
        'individual_type',
        'delivery_type',
        'company_type',
        'order_item_status',
        'batch_status',
      ])
      .subscribe(data => {
        this.individualTypes = [...data.individual_type];
        this.allIndividualTypes = [...data.individual_type];
        this.deliveryTypes = data.delivery_type;
        this.companyTypes = data.company_type;
        this.orderItemStatuses = data.order_item_status;
        this.batchStatuses = data.batch_status;
      });

    this.individualDetailsForm
      .valueChanges
      .subscribe(value => {
        this._dirtinessService.setDirty(true);
      })

    this.companyDetailsForm
      .valueChanges
      .subscribe(value => {
        this._dirtinessService.setDirty(true);
      });

    this.selectEntityTypeForm
      .controls['entityType']
      .valueChanges
      .subscribe(value => {
        this.individualFirstName = null;
        this.individualLastName = null;
        this.companyName = null;
        switch (value) {
          case this.EntityType.Company:
            this.individualTypes = this.allIndividualTypes;
            break;
          case this.EntityType.Individual:
            this.individualTypes = this.individualTypes
              .filter(type => type.code != 'PHM')
            break;
        }
      });

    this.companyDetailsForm
      .controls['typeOfBusiness']
      .valueChanges
      .subscribe(value => {
        // choose to show or not show distributor field
        const companyType: CompanyType | undefined = this.companyTypes.find(type => type.id === value)

        this.showDistributor = companyType ? (companyType.code !== 'DIS' ? true : false) : false;

        if (companyType) {
          if (companyType.code === 'DIS') {
            this.showDistributor = false;
            this.companyDetailsForm.patchValue({
              distributor: null
            })
          } else {
            this.showDistributor = true;
          }
        }
        else {
          this.showDistributor = false;
        }
      });

    this.companyDetailsForm.controls['companyName']
      .valueChanges.subscribe(value => {
        this.companyName = value;
      });

    this.individualDetailsForm.controls['firstName']
      .valueChanges.subscribe(value => {
        this.individualFirstName = value;
      })

    this.individualDetailsForm.controls['lastName']
      .valueChanges.subscribe(value => {
        this.individualLastName = value;
      })
  }

  _filterCountries(value: string) {
    if (!value) return this.countries;
    return this
      .countries
      .filter((country) => {
        return country
          .name
          .toLowerCase()
          .includes(
            value.toLowerCase()
          )
      })
  }

  stepChanged(event: StepperSelectionEvent) {

    if (event.previouslySelectedIndex > event.selectedIndex)
      event.selectedStep.interacted = false;

    if (event.previouslySelectedIndex < event.selectedIndex && event.selectedStep.interacted) {
      event.selectedStep.interacted = false;
    }

  }

  onMedicineStepInteraction(event: any) {
  }

  addOrderItem(item: any) {
    this.orderItems.push(item);
    this.orderItems = [
      ...this.orderItems
    ]
    this._dirtinessService.setDirty(true);
  }


  removeOrderItem(item: OrderItem) {
    const index = this.orderItems.indexOf(item);
    if (index > -1)
      this.orderItems.splice(index, 1);
    this.orderItems = [
      ...this.orderItems
    ]
    this._dirtinessService.setDirty(true);
  }

  onFileUploaded(success: boolean) {
    if (success && this.order) {
      this._dirtinessService.setDirty(false);
      this._router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => {
          this._router.navigate(['/portal/submit']);
        })
    }
  }

  save() {
    const medicine = this
      .orderItems
      .map(item => (
        {
          id: undefined,
          quantity: item.quantity,
          medicine_dosage_package_type_id: item.medicineDosagePackageType.id,
          order_item_status_id: item.status ? item.status.id : null,
          deleted_at: undefined,
        }));



    const payload: PrescriptionCreatePayload = {

      individual: this.individualDetailsForm.valid ? {
        id: this.selectedIndividual ? this.selectedIndividual.id : undefined,
        profile_number: undefined,
        first_name: this.individualDetailsForm.value.firstName,
        last_name: this.individualDetailsForm.value.lastName,
        initials: this.individualDetailsForm.value.initials,
        gender: this.individualDetailsForm.value.gender,
        title: this.individualDetailsForm.value.title,
        dependant_number: this.individualDetailsForm.value.numberOfDependants,
        date_of_birth: this.individualDetailsForm.value.dateOfBirth,
        is_animal: this.individualDetailsForm.value.isAnimal,
        phone_number: this.individualDetailsForm.value.phoneNumber,
        phone_number_alt: this.individualDetailsForm.value.phoneNumberAlt,
        individual_type_id: this.individualDetailsForm.value.individualType,
        email: this.individualDetailsForm.value.email,
        email_alt: this.individualDetailsForm.value.emailAlt
      } : undefined,

      address: {
        building_apt_number: this.addressDetailsForm.value.buildingAptNumber,
        address_1: this.addressDetailsForm.value.addressLine1,
        address_2: this.addressDetailsForm.value.addressLine2,
        province: this.addressDetailsForm.value.province,
        city: this.addressDetailsForm.value.city,
        postcode: this.addressDetailsForm.value.postcode,
        country: this.addressDetailsForm.value.country,
        delivery_type_id: this.addressDetailsForm.value.deliveryType
      },

      company: this.companyDetailsForm.valid ? {
        id: this.selectedCompany ? this.selectedCompany.id : undefined,
        name: this.companyDetailsForm.value.name,
        email: this.companyDetailsForm.value.email,
        email_alt: this.companyDetailsForm.value.emailAlt,
        phone_number: this.companyDetailsForm.value.phoneNumber,
        phone_number_alt: this.companyDetailsForm.value.phoneNumberAlt,
        practice_number: this.companyDetailsForm.value.practiceNumber,
        vat_registration_number: this.companyDetailsForm.value.vatRegistrationNumber,
        company_type_id: this.companyDetailsForm.value.typeOfBusiness,
        distributor_id: this.selectedDistributor ? this.selectedDistributor.id : undefined
      } : undefined,

      prescriber: this.prescriberDetailsForm.valid ? {
        id: this.selectedPrescriber ? this.selectedPrescriber.id : undefined,
        profile_number: undefined,
        first_name: this.prescriberDetailsForm.value.firstName,
        last_name: this.prescriberDetailsForm.value.lastName,
        initials: this.prescriberDetailsForm.value.initials,
        gender: this.prescriberDetailsForm.value.gender,
        title: this.prescriberDetailsForm.value.title,
        dependant_number: this.prescriberDetailsForm.value.numberOfDependants,
        date_of_birth: this.prescriberDetailsForm.value.dateOfBirth,
        is_animal: this.prescriberDetailsForm.value.isAnimal,
        phone_number: this.prescriberDetailsForm.value.phoneNumber,
        phone_number_alt: this.prescriberDetailsForm.value.phoneNumberAlt,
        individual_type_id: this.prescriberDetailsForm.value.individualType,
        email: this.prescriberDetailsForm.value.email,
        email_alt: this.prescriberDetailsForm.value.emailAlt
      } : undefined,

      medicine,
      additional_details: this.additionalDetailsForm.valid ? {
        customer_order_number :this.additionalDetailsForm.value.customerOrderNumber
      }:undefined,
    };

    (async () => {

      this.disableSaveButton = true;

      const response = await this._formService.submitPrescription(payload);

      this.disableSaveButton = false;

      if (!response) return;

      if (!response.success) {
        this.disableSaveButton = false;
        return;
      }

      this.order = response.data;
      this.isEditable = false;
      this._stepper.next();
    })();

  }


  async openSearchIndividualDialog() {
    this.selectedIndividual = await this._individualService
      .openIndividualSearchDialog(
        "Search for an individual",
        "",
        "VET,DOC,PNT"
      );


    if (!this.selectedIndividual) return;

    this.individualDetailsForm
      .patchValue({
        firstName: this.selectedIndividual.first_name,
        lastName: this.selectedIndividual.last_name,
        title: this.selectedIndividual.title,
        initials: this.selectedIndividual.initials,
        gender: this.selectedIndividual.gender,
        isAnimal: this.selectedIndividual.is_animal === 1 ? true : false,
        dateOfBirth: this.selectedIndividual.date_of_birth,
        phoneNumber: this.selectedIndividual.phone_number,
        phoneNumberAlt: this.selectedIndividual.phone_number_alt,
        email: this.selectedIndividual.email,
        emailAlt: this.selectedIndividual.email_alt,
        individualType: this.selectedIndividual.individual_type_id,
        numberOfDependants: this.selectedIndividual.dependant_number,
      });

    // Update the address 

    const address: Address | null = this.selectedIndividual
      .addresses ? (this.selectedIndividual
        .addresses
        .length > 0 ? this.selectedIndividual
          .addresses[0] : null)
      : null;

    this.addressDetailsForm
      .patchValue({
        buildingAptNumber: address ? address.building_apt_number : "",
        addressLine1: address ? address.address_1 : "",
        addressLine2: address ? address.address_2 : "",
        city: address ? address.city : "",
        province: address ? address.province : "",
        postcode: address ? address.postcode : "",
        country: address ? address.country : "",
      });

  }

  deselectIndividual() {
    this.selectedIndividual = null;
    this.individualDetailsForm
      .patchValue({
        firstName: "",
        lastName: "",
        title: "",
        initials: "",
        gender: "",
        dateOfBirth: "",
        phoneNumber: "",
        phoneNumberAlt: "",
        email: "",
        emailAlt: "",
        individualType: "",
        numberOfDependants: ""
      });

    this.addressDetailsForm
      .patchValue({
        buildingAptNumber: "",
        addressLine1: "",
        city: "",
        addressLine2: "",
        province: "",
        postcode: "",
        country: "",
        deliveryType: ""
      });
  }

  async openSearchCompanyDialog() {
    this.selectedCompany = await this._companyService
      .openCompanySearchDialog();

    if (!this.selectedCompany) return;

    this
      .companyDetailsForm
      .patchValue({
        companyName: this.selectedCompany.name,
        email: this.selectedCompany.email,
        emailAlt: this.selectedCompany.email_alt,
        phoneNumber: this.selectedCompany.phone_number,
        phoneNumberAlt: this.selectedCompany.phone_number_alt,
        practiceNumber: this.selectedCompany.practice_number,
        vatRegistrationNumber: this.selectedCompany.vat_registration_number,
        typeOfBusiness: this.selectedCompany.company_type_id
      });

    const address: Address | null = this.selectedCompany
      .addresses ? (this.selectedCompany
        .addresses.length > 0 ? this.selectedCompany
          .addresses[0] : null)
      : null;

    this.addressDetailsForm
      .patchValue({
        buildingAptNumber: address ? address.building_apt_number : "",
        addressLine1: address ? address.address_1 : "",
        addressLine2: address ? address.address_2 : "",
        city: address ? address.city : "",
        province: address ? address.province : "",
        postcode: address ? address.postcode : "",
        country: address ? address.country : "",
      });

    this.selectedDistributor = this.selectedCompany.distributor;

  }

  deselectCompany() {
    this.selectedCompany = null;
    this.selectedDistributor = null;
    this
      .companyDetailsForm
      .patchValue({
        companyName: "",
        email: "",
        emailAlt: "",
        phoneNumber: "",
        phoneNumberAlt: "",
        practiceNumber: "",
        vatRegistrationNumber: "",
        typeOfBusiness: ""
      });

    this.addressDetailsForm
      .patchValue({
        buildingAptNumber: "",
        addressLine1: "",
        city: "",
        addressLine2: "",
        province: "",
        postcode: "",
        country: "",
        deliveryType: ""
      });
  }

  async openSearchPrescriberDialog() {
    this.selectedPrescriber = await this._individualService
      .openIndividualSearchDialog("Search for an individual", "", "VET,DOC,PHM", this.selectedCompany);

    if (!this.selectedPrescriber) return;
    this
      .prescriberDetailsForm
      .patchValue({
        firstName: this.selectedPrescriber.first_name,
        lastName: this.selectedPrescriber.last_name,
        title: this.selectedPrescriber.title,
        initials: this.selectedPrescriber.initials,
        gender: this.selectedPrescriber.gender,
        isAnimal: false,
        dateOfBirth: this.selectedPrescriber.date_of_birth,
        phoneNumber: this.selectedPrescriber.phone_number,
        phoneNumberAlt: this.selectedPrescriber.phone_number_alt,
        email: this.selectedPrescriber.email,
        emailAlt: this.selectedPrescriber.email_alt,
        individualType: this.selectedPrescriber.individual_type_id,
        numberOfDependants: this.selectedPrescriber.dependant_number,
      });

  }

  deselectPrescriber() {
    this.selectedPrescriber = null;
    this.prescriberDetailsForm
      .patchValue({
        firstName: "",
        lastName: "",
        title: "",
        initials: "",
        gender: "",
        dateOfBirth: "",
        phoneNumber: "",
        phoneNumberAlt: "",
        email: "",
        emailAlt: "",
        individualType: "",
        numberOfDependants: ""
      });
  }

  async openSearchDistributorDialog() {
    this.selectedDistributor = await this._companyService
      .openCompanySearchDialog("Search for a distributor", "", "DIS");

    if (!this.selectedDistributor) return;

    this
      .companyDetailsForm
      .patchValue({
        distributor: this.selectedDistributor
      });

  }

  deselectDistributor() {
    this.selectedDistributor = null;
    this
      .companyDetailsForm
      .patchValue({
        distributor: null,
        distributorName: ""
      });
  }

  submitPrescription() {
    this.save();
  }

  togglePrescriberDetailsStep(event: MatCheckboxChange) {
    this.displayPrescriberDetailsForm = event.checked;
    if (!event.checked) {
      // this.selectedDistributor = null;
      this.prescriberDetailsForm.reset();
      this.prescriberDetailsForm.markAsPristine();
    }
  }
}
